module.exports = __webpack_public_path__ + "img/tip-icon1.be1b4297.png";